module.exports = __webpack_public_path__ + "img/29_54.08f83ebe.png";